import { deleteApi, get, post } from "../GenericServices";

const CreditCard = {
  getCreditCards: (queryString) => {
    return get(`credit-card${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getCreditCard: (id) => {
    return get(`credit-card/${id}`);
  },
  setCreditCard: (data) => {
    return post(`credit-card`, data);
  },
  deleteCreditCard: (id) => {
    return deleteApi(`credit-card/${id}`);
  },
  downloadExportFile: () => {
    return get(`credit-card/export`);
  },
};

export default CreditCard;
